import React, { useContext, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { HeaderHLPure, GridPure, SearchBarHLPure, ButtonAddHLPure } from "../../pures";
import { Link } from 'react-router-dom'
import { Context } from "../../../Context";

const SurveyView = (props) => {
  const { allowedActions } = useContext(Context);
  const { t } = useTranslation();
  const { t: transl } = useTranslation('survey', { keyPrefix: 'surveyScreen' });
  const [selectedValueFilter, setSelectedValue] = useState("Pendiente")
  const { deleteSurvey } = props
  const hideActions = useMediaQuery('(max-width: 820px)');

  const [searchSurvey, setSearchSurvey] = useState('');

  const handleChangeSearch = (e) => setSearchSurvey(e.target.value);

  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  const data = props.surveys

  const surveysGrid = useMemo(() => {
    if (!searchSurvey) return data;

    const lowercasedSearchSurvey = searchSurvey.toLowerCase();
    const filteredSurveys = data.filter(el => el.title.toLowerCase().includes(lowercasedSearchSurvey))
    return filteredSurveys
  }, [data, searchSurvey])


  return (
    <Container className="view-container surveyView">
      <Grid container spacing={2}>
        {/* Table and Header */}
        <Grid item xs={12}>
          <HeaderHLPure title={t("surveyView.title")} />
        </Grid>
        <Grid item xs={12} className="add-and-search-container">
          <Link to='add-survey' style={{ textDecoration: 'none' }}>
            {
              allowedActions && allowedActions.create &&
              <ButtonAddHLPure
                iconAdd={true}
                nameBtn={transl("buttonAdd")}
                onClick={() => { console.log('Encuesta') }}
              />
            }
          </Link>
          <SearchBarHLPure
            placeholder={t("search")}
            labelFilter="Filtrar por"
            options={props.optionsFilter}
            nameOption="status"
            statusValueFilter={selectedValueFilter === true ? "Activo" : selectedValueFilter === false ? "Inactivo" : "Todos"}
            optionsValue={"Todos"}
            onFilterChange={(e) => filterChange(e)}
            onSearchChange={((e) => handleChangeSearch(e))}
          />
        </Grid>
        <Grid item xs={12}>
          <GridPure
            {...props}
            dataGrid={surveysGrid}
            skip={0}
            take={11}
            rowsItems={[{
              field: 'title',
              title: t("surveyView.columnName"),
              width: 200,
              sorteable: true
            },
            {
              field: 'startDate',
              title: t("surveyView.columnStartDate"),
              width: 130,
              sorteable: true
            },
            {
              field: 'endDate',
              title: t("surveyView.columnEndDate"),
              width: 130,
              sorteable: true
            },
            {
              field: 'Acciones',
              title: hideActions ? '' : t("surveyView.columnActions"),
              width: hideActions ? 75 : 150,
              actions: true,
              headerClassName: 'actionHeader'
            }]}
            actions={[
              {
                type: 'view-details',
                value: t('gridPure.columnActions.details'),
                onClick: (dataItem) => { props.goToDetails(dataItem) }
              },
              {
                type: 'label',
                value: t("surveyView.answers"),
                onClick: (dataItem) => { props.goToAnswers(dataItem) }
              },
              allowedActions && allowedActions.delete &&
              {
                type: 'icon',
                value: 'k-icon k-i-delete k-i-trash',
                onClick: (dataItem) => { deleteSurvey(dataItem.id) }
              },
            ]}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export { SurveyView as default };